import { createRouter, createWebHashHistory } from "vue-router";
import store from "../store/index";
const routes = [
    {
        path: "/login",
        name: "login",
        component: () =>
            import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
    },
    {
        path: "/",
        name: "home",
        component: () =>
            import(
                /* webpackChunkName: "container" */ "@/views/container/index.vue"
            ),
    },
    {
        path: "/404",
        name: "404",
        component: () =>
            import(/* webpackChunkName: "404" */ "@/views/404/index.vue"),
    },
    {
        path: "/:pathMatch(.*)",
        redirect: "/login",
    },
];

export const roleRouters = [
    {
        path: "userManage",
        name: "userManage",
        meta: {
            title: "用户管理",
            auth: "userManage",
        },
        component: () =>
            import(
                /* webpackChunkName: "userManage" */ "@/views/userManage/index.vue"
            ),
    },
    {
        path: "userDeposit",
        name: "userDeposit",
        meta: {
            title: "充值记录",
            auth: "userDeposit",
        },
        component: () =>
            import(
                /* webpackChunkName: "userManage" */ "@/views/userDeposit/index.vue"
                ),
    },
    {
        path: "orderManage",
        name: "orderManage",
        meta: {
            title: "订单管理",
            auth: "orderManage",
        },
        component: () =>
            import(
                /* webpackChunkName: "orderManage" */ "@/views/orderManage/index.vue"
            ),
    },
    {
        path: "carWashFee",
        name: "carWashFee",
        meta: {
            title: "洗车费配置",
            auth: "carWashFee",
        },
        component: () =>
            import(
                /* webpackChunkName: "carWashFee" */ "@/views/carWashFee/index.vue"
                ),
    },
    {
        path: "carWashPackageManagement",
        name: "carWashPackageManagement",
        meta: {
            title: "洗车套餐管理",
            auth: "carWashPackageManagement",
        },
        component: () =>
            import(
                /* webpackChunkName: "carWashPackageManagement" */ "@/views/carWashPackageManagement/index.vue"
                ),
    },
    {
        path: "carWashVideoManagement",
        name: "carWashVideoManagement",
        meta: {
            title: "洗车视频管理",
            auth: "carWashVideoManagement",
        },
        component: () =>
            import(
                /* webpackChunkName: "carWashPackageManagement" */ "@/views/carWashVideoManagement/index.vue"
                ),
    },
    {
        path: "parkingManage",
        name: "parkingManage",
        meta: {
            title: "站点管理",
            auth: "parkingManage",
        },
        component: () =>
            import(
                /* webpackChunkName: "parkingManage" */ "@/views/parkingManage/index.vue"
            ),
    },
    {
        path: "reportManage",
        name: "reportManage",
        meta: {
            title: "营收报表",
            auth: "reportManage",
        },
        component: () =>
            import(
                /* webpackChunkName: "activityManage" */ "@/views/reportManage/index.vue"
            ),
    },
    {
        path: "operationalStatistics",
        name: "operationalStatistics",
        meta: {
            title: "运营统计",
            auth: "operationalStatistics",
        },
        component: () =>
            import(
                /* webpackChunkName: "activityManage" */ "@/views/operationalStatistics/index.vue"
                ),
    },
    {
        path: "recharge",
        name: "recharge",
        meta: {
            title: "充值配置",
            auth: "recharge",
        },
        component: () =>
            import(
                /* webpackChunkName: "activityManage" */ "@/views/recharge/index.vue"
            ),
    },
    {
        path: "permissionManagement",
        name: "permissionManagement",
        meta: {
            title: "权限管理",
            auth: "permissionManagement",
        },
        redirect: "/permissionManagement/permissionManagement",
        children: [
            {
                path: "/permissionManagement/menuPermissions",
                name: "menuPermissions",
                meta: {
                    title: "菜单权限",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "systemSettings" */ "@/views/permissionManagement/menuPermissions.vue"
                        ),
            },
            {
                path: "/permissionManagement/dataPermissions",
                name: "dataPermissions",
                meta: {
                    title: "数据权限",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "sysConfigure" */ "@/views/permissionManagement/dataPermissions.vue"
                        ),
            },
        ],
    },
    {
        path: "hardwareSettings",
        name: "hardwareSettings",
        meta: {
            title: "硬件管理",
            auth: "hardwareSettings",
        },
        redirect: "/hardwareSettings/hardwareSettings",
        component: () =>
            import(
                /* webpackChunkName: "systemWrap" */ "@/views/hardwareSettings/index.vue"
                ),
        children: [
            {
                path: "/hardwareSettings/statusIndex",
                name: "hardwareStatusSetting",
                meta: {
                    title: "设备状态",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "systemSettings" */ "@/views/hardwareSettings/statusIndex.vue"
                        ),
            },
            {
                path: "/hardwareSettings/infoIndex",
                name: "hardwareInfoSetting",
                meta: {
                    title: "设备信息",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "systemSettings" */ "@/views/hardwareSettings/infoIndex.vue"
                        ),
            },
            {
                path: "/hardwareSettings/settingIndex",
                name: "hardwareConfiguration",
                meta: {
                    title: "硬件配置",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "systemSettings" */ "@/views/hardwareSettings/settingIndex.vue"
                        ),
            }
        ],
    },
    {
        path: "systemSettings",
        name: "systemSettings",
        meta: {
            title: "系统管理",
            auth: "systemSettings",
        },
        redirect: "/systemSettings/systemSettings",
        component: () =>
            import(
                /* webpackChunkName: "systemWrap" */ "@/views/systemWrap/index.vue"
            ),
        children: [
            {
                path: "/systemSettings/systemSettings",
                name: "systemSettingsa",
                meta: {
                    title: "系统设置",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "systemSettings" */ "@/views/systemSettings/index.vue"
                    ),
            },
            {
                path: "/systemSettings/sysConfigure",
                name: "sysConfigure",
                meta: {
                    title: "系统配置",
                },
                component: () =>
                    import(
                        /* webpackChunkName: "sysConfigure" */ "@/views/sysConfigure/index.vue"
                    ),
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    let userInfo = localStorage.getItem("userInfo") || JSON.stringify({});
    userInfo = JSON.parse(userInfo);
    if (!userInfo.userId && to.name === "login") {
        next();
    } else {
        const userMenu = store.state.userMenu;
        if (userMenu.length) {
            next();
        } else {
            console.log("userInfo.userId:", userInfo.userId);
            if (userInfo.userId) {
                const roleMenu = await store.dispatch(
                    "asyncSetUserMenu",
                    userInfo
                );
                router.addRoute({
                    path: "/",
                    name: "home",
                    redirect: `/${roleMenu[0].path}`,
                    component: () =>
                        import(
                            /* webpackChunkName: "container" */ "@/views/container/index.vue"
                        ),
                    children: roleMenu,
                });
                next({ path: `/${roleMenu[0].path}` });
            } else {
                next({ name: "login" });
            }
        }
    }
});

export default router;
